import React, {
  useEffect,
  useState,
  useLayoutEffect,
  useCallback,
  useRef,
} from "react";
import axios from "axios";
import { CAR_REPORT_DETAIL, CAR_REPORT } from "../../constant";
import { POST, GET } from "../../constant/apiMethods";
import { connect } from "react-redux";
import Labels from "../../services/apiLabels";
import config from "../../config";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import "./style.css";
import ReportPhotoViewer from "./ReportPhotoViewer";
import ImageView from "./imgeviw";
import ImageGallery from "react-image-gallery";
import { FaPlus, FaMinus, FaTimes, FaQuestionCircle } from "react-icons/fa";
import { GrFormSubtract } from "react-icons/gr";
import { ShimmerThumbnail } from "react-shimmer-effects";
import ImgsViewer from "react-images-viewer";
import Car_img from "../../assets/images/hassan2.jpg";
import Car_img2 from "../../assets/images/car_damage.png";
import carDiagram from "../../assets/images/carnew.jpg";
import { useHistory } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import TextField from "@mui/material/TextField";
import PuffLoader from "react-spinners/ClipLoader";
import { BiImage } from "react-icons/bi";
import ImageViewer from "react-simple-image-viewer";

import { ProgressBar } from "react-bootstrap";
import ProgressNew from "./progres.js";
import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import Progress from "../../components/Progress";

import { useContext } from "react";
import FeedbackContext from "../../context/cmscontext";

const MAP_WIDTH = 553;
const MAP_HEIGHT = 406;

function unwrapReportList(raw) {
  if (Array.isArray(raw)) return raw;
  if (Array.isArray(raw?.data)) return raw.data;
  return [];
}

function mapOffset(value, total) {
  if (value == null || value === "") return "0%";
  const str = String(value).trim();
  if (str.endsWith("%")) return str;
  const n = parseFloat(str);
  if (!Number.isFinite(n) || !total) return "0%";
  return `${(n / total) * 100}%`;
}

function pickPointPhoto(item) {
  if (!item || typeof item !== "object") return "";
  const photo =
    item.photo_url ||
    item.photoUrl ||
    item.image ||
    item.imgs ||
    item.img ||
    "";
  return typeof photo === "string" ? photo : "";
}

function formatPointDate(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString();
}

function roundScore(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 10) / 10;
}

function questionPenalty(question) {
  const selected = question?.selected_inspection_question?.[0];
  const raw = selected?.damage ?? question?.count ?? 0;
  const n = Number(raw);
  return Number.isFinite(n) ? n : 0;
}

function sectionScoreFromFormula(section) {
  const questions = Array.isArray(section?.inspection_title)
    ? section.inspection_title
    : [];
  const penalty = questions.reduce(
    (sum, question) => sum + questionPenalty(question),
    0
  );
  return {
    title: section?.title || "Section",
    questions: questions.length,
    penalty: roundScore(penalty),
    score: roundScore(Math.max(0, Math.min(100, 100 - penalty))),
  };
}

const DAMAGE_MARKER_WEIGHTS = {
  P: 1,
  D1: 2,
  D2: 3,
  D3: 4,
  A: 5,
  S: 4,
  W: 3,
  R: 2,
};

const MARKER_COLORS = {
  P: { bg: "#0284c7", ring: "rgba(2, 132, 199, 0.45)" },
  D1: { bg: "#d97706", ring: "rgba(217, 119, 6, 0.5)" },
  D2: { bg: "#ea580c", ring: "rgba(234, 88, 12, 0.5)" },
  D3: { bg: "#dc2626", ring: "rgba(220, 38, 38, 0.55)" },
  A: { bg: "#b91c1c", ring: "rgba(185, 28, 28, 0.55)" },
  S: { bg: "#7c3aed", ring: "rgba(124, 58, 237, 0.5)" },
  W: { bg: "#475569", ring: "rgba(71, 85, 105, 0.45)" },
  R: { bg: "#2563eb", ring: "rgba(37, 99, 235, 0.5)" },
};

function markerKey(value) {
  return String(value || "").trim().toUpperCase();
}

function markerColor(symbol) {
  return MARKER_COLORS[markerKey(symbol)] || MARKER_COLORS.R;
}

function scoreTone(score) {
  const n = Number(score) || 0;
  if (n >= 90) return { key: "excellent", label: "Excellent", color: "#059669" };
  if (n >= 75) return { key: "good", label: "Good", color: "#2563eb" };
  if (n >= 60) return { key: "fair", label: "Fair", color: "#d97706" };
  return { key: "poor", label: "Needs work", color: "#dc2626" };
}

function markerWeight(point) {
  const key = markerKey(point?.symbol);
  if (Object.prototype.hasOwnProperty.call(DAMAGE_MARKER_WEIGHTS, key)) {
    return DAMAGE_MARKER_WEIGHTS[key];
  }
  return 2;
}

function buildLegend(apiTypes, points) {
  const bySymbol = new Map();
  (Array.isArray(apiTypes) ? apiTypes : []).forEach((item) => {
    const symbol = markerKey(item?.symbol);
    if (!symbol) return;
    bySymbol.set(symbol, {
      symbol,
      title: item.title || symbol,
      count: 0,
    });
  });
  (Array.isArray(points) ? points : []).forEach((item) => {
    const symbol = markerKey(item?.symbol);
    if (!symbol) return;
    const current = bySymbol.get(symbol) || {
      symbol,
      title: item.title || symbol,
      count: 0,
    };
    current.count += 1;
    if (item.title && current.title === symbol) current.title = item.title;
    bySymbol.set(symbol, current);
  });
  return [...bySymbol.values()];
}

function damageMapScore(points) {
  const list = Array.isArray(points) ? points : [];
  const penalty = list.reduce((sum, point) => sum + markerWeight(point), 0);
  return {
    title: "Damage map",
    questions: list.length,
    penalty: roundScore(penalty),
    score: roundScore(Math.max(0, Math.min(100, 100 - penalty))),
    kind: "map",
  };
}

function overallFromSections(sections, points) {
  const parts = (Array.isArray(sections) ? sections : []).map(
    sectionScoreFromFormula
  );
  const mapPart = damageMapScore(points);
  if (mapPart.questions > 0) parts.push(mapPart);
  if (!parts.length) {
    return { score: 0, parts };
  }
  const score = roundScore(
    parts.reduce((sum, part) => sum + part.score, 0) / parts.length
  );
  return { score, parts };
}

export const CarReport = ({
  car_report_detail_data_new,
  winerListloading,
  car_report_detail_call,
  car_report_call,
  car_report_data,
  car_report_detail_data,
  loading,
}) => {
  const location = useLocation();
  const { feedback, isLoading } = useContext(FeedbackContext);
  var car_report_page = feedback.car_report_page || {};
  // A failed report call leaves these as the reducer's initial value, so the
  // page must not assume the API shape is present.
  const damagePoints = unwrapReportList(car_report_data);
  const inspectionSections = unwrapReportList(car_report_detail_data);
  const hasReport = damagePoints.length > 0 || inspectionSections.length > 0;
  // Opened from the lot with router state, but a refresh or shared link only
  // carries the query string, so accept both.
  const productCode =
    location.state?.product_code ??
    new URLSearchParams(location.search).get("id") ??
    "";
  const [divshow, setdivshow] = useState("false");
  var actualInnerWidth = document.body.clientWidth;
  var actualInnerHight = document.documentElement.clientHeight;
  console.log(car_report_detail_data_new)
  // const [screenwidth,setwidth]=useState(actualInnerWidth);
  // document.body.style.background = "#F2F4F5"
  const [inpvalue, setInpvalue] = useState();

  const [postcode, setpostcode] = useState();
  const [desp, setdesp] = useState();
  const [left, setleft] = useState();
  const [top, settop] = useState();
  const [report, setReport] = useState(false)
  const [condition, setCondition] = useState(null);
  // function updateSize() {
  //   setSize([window.innerWidth, window.innerHeight]);
  // }
  // window.addEventListener('resize', updateSize);
  // useLayoutEffect(() => {
  //   actualInnerWidth = document.body.clientWidth;
  //
  //   // function updateSize() {
  //   //   setSize([window.innerWidth, window.innerHeight]);
  //   // }
  //   // window.addEventListener('resize', updateSize);
  //   // updateSize();
  //   // return () => window.removeEventListener('resize', updateSize);
  // },);
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [gallery, setGallery] = useState({ open: false, items: [], index: 0 });
  const [scoreHelpOpen, setScoreHelpOpen] = useState(false);
  const scoreHelpRef = useRef(null);

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  const imagewiewopen = () => {};

  const [images, setimages] = useState([
    "//placekitten.com/1500/500",
    "//placekitten.com/4000/3000",
    "//placekitten.com/800/1200",
    "//placekitten.com/1500/1500",
  ]);

  const [apipics, setapipics] = useState([]);

  // console.log"images galery",images,"apipics",apipics)

  const openGallery = useCallback((items, start = 0) => {
    const clean = (items || []).filter((item) => item && item.src);
    if (!clean.length) return;
    setGallery({
      open: true,
      items: clean,
      index: Math.max(0, Math.min(start, clean.length - 1)),
    });
  }, []);

  const closeGallery = useCallback(() => {
    setGallery({ open: false, items: [], index: 0 });
    setIsViewerOpen(false);
  }, []);

  const imge_wiew = (data) => {
    const items = (Array.isArray(data) ? data : [])
      .map((item, index) => {
        if (!item) return null;
        if (typeof item === "string") {
          return { src: item, label: "Inspection photo", symbol: String(index + 1) };
        }
        const src = item.image || item.photo_url || item.src || "";
        if (!src) return null;
        return {
          src,
          label: item.title || item.label || "Inspection photo",
          symbol: item.symbol || String(index + 1),
        };
      })
      .filter(Boolean);
    openGallery(items, 0);
  };

  const [activePoint, setActivePoint] = useState(null);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [legendTypes, setLegendTypes] = useState([]);
  const pointInfoRef = useRef(null);

  // console.log"useEffectuseEffectuseEffect===============",location.state.product_code )

  useEffect(() => {
    if (!productCode) return;
    setActivePoint(null);
    setActiveIndex(-1);
    car_report_call({ id: productCode });
    car_report_detail_call({ id: productCode });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productCode]);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${config.baseUrl}api/show_legend_car/`)
      .then((response) => {
        if (cancelled) return;
        const list = unwrapReportList(response?.data?.data ?? response?.data);
        setLegendTypes(list);
      })
      .catch(() => {
        if (!cancelled) setLegendTypes([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!activePoint || !pointInfoRef.current) return;
    pointInfoRef.current.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
    });
  }, [activePoint]);

  useEffect(() => {
    if (!scoreHelpOpen) return;
    const onPointerDown = (event) => {
      if (scoreHelpRef.current && !scoreHelpRef.current.contains(event.target)) {
        setScoreHelpOpen(false);
      }
    };
    document.addEventListener("pointerdown", onPointerDown);
    return () => document.removeEventListener("pointerdown", onPointerDown);
  }, [scoreHelpOpen]);

  function refreshPage() {
    window.location.reload();
  }

  // console.log"show data api",car_report_data)

  const [openSections, setOpenSections] = useState(null);

  const isSectionOpen = (index) =>
    openSections == null ? true : openSections.has(index);

  const toggleSection = (index) => {
    setOpenSections((prev) => {
      const current =
        prev == null
          ? new Set(inspectionSections.map((_, i) => i))
          : new Set(prev);
      if (current.has(index)) current.delete(index);
      else current.add(index);
      return current;
    });
  };

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  // console.logactualInnerWidth,"inp value =======widthwidth=====",actualInnerHight)

  // actualInnerWidth = document.body.clientWidth;

  // document.body.style.zoom = "70%";
  console.log(car_report_data)
  const history = useHistory();

  var main = document.getElementById("main");
  var car_div = document.getElementById("car_div");
  var point = document.getElementById("point");
  var point2 = document.getElementById("point2");
  var line = document.getElementById("overlay_pointer");

  var line_botm = document.getElementById("line_botm");
  var btotm_div = document.getElementById("btotm_div");

  const handler = () => {
    var canvas = document.getElementById("viewport");
    if (!canvas) return;
    var context = canvas.getContext("2d");
    var base_image = new Image();
    base_image.src =
      "https://backend.sellanywheel.com/static/staticimages/car_certification_v2-e9ae77bea60843256dbd759106c2911e.jpg";
    base_image.onload = function () {
      context.drawImage(base_image, 0, 0);
    };
    main = document.getElementById("main");
    car_div = document.getElementById("car_div");
    point = document.getElementById("point");
    point2 = document.getElementById("point2");
    line = document.getElementById("overlay_pointer");

    line_botm = document.getElementById("line_botm");
    btotm_div = document.getElementById("btotm_div");
  };
  // window.addEventListener('load', handler);

  const [carpic_, setcarpic_] = useState();

  const [cardivshow, setcardivshow] = useState(false);

  // console.log"car pic....",carpic_)

  const dam1 = (data) => {
    car_div = car_div || document.getElementById("car_div");
    line = line || document.getElementById("overlay_pointer");
    line_botm = line_botm || document.getElementById("line_botm");
    btotm_div = btotm_div || document.getElementById("btotm_div");
    if (!car_div || !line || !line_botm || !btotm_div) return;
    car_div.style.display = "block";

    setcardivshow(true);
    setcarpic_(data.item.photo_url);

    // console.log"chk our condtio",data.item)
    if (width <= 900) {
      // console.log"chk condtion if small screen",actualInnerWidth)

      settop(parseInt(data.item.top, 10));
      // console.log"chk our condtio")
      // line_botm.style.height="440px"
      line_botm.style.display = "block";
      line.style.display = "none";
      const line_h2 = parseInt(data.item.left, 10) + 45;

      const line_height = parseInt(data.item.top, 10) + 15;
      const height_remove = parseInt(line_botm.style.height, 10) - line_height;

      line_botm.style.height = `${height_remove}px`;

      line_botm.style.left = `${line_h2}px`;
      const botm_div_left = parseInt(data.item.left, 10) - 50;
      btotm_div.style.left = `${botm_div_left}px`;
    } else {
      // console.log"chk condtion if large screen",actualInnerWidth)
      setleft(parseInt(data.item.left, 10));
      setcardivshow(true);
      setcarpic_(data.item.photo_url);
      line.style.width = `${actualInnerWidth - 450}px`;
      line.style.display = "block";
      line_botm.style.display = "none";
      // car_div.style.display="block"
      const bbb = parseInt(data.item.top, 10) + 65;
      car_div.style.top = `${bbb}px`;
      // // console.log"inp value ======r",line.style.width,"rrrrrrrrrrrrrrrrr======",point.style.left)
      const remove = parseInt(data.item.left, 10) + 5;
      const asas = actualInnerWidth - 310 - remove;

      // line.style.width=`${asas}px`

      // console.log"inp value ==2222222====r",line.style.width,"rrrrrrrrrrrrrrrrr======",asas)
    }
  };

  const dam2 = () => {
    line_botm.style.height = "440px";

    const line_h2 = parseInt(point2.style.left, 10) + 45;

    const line_height = parseInt(point2.style.top, 10) + 15;
    const height_remove = parseInt(line_botm.style.height, 10) - line_height;

    line_botm.style.height = `${height_remove}px`;

    line_botm.style.left = `${line_h2}px`;

    // console.log"chk botom line",line_height,"ssss",line_botm.style.height,"ssss",height_remove)

    //   line.style.width="1130px"
    //   line.style.display="block"
    //   const bbb=parseInt(point2.style.top, 10)+65
    //   car_div.style.top=`${bbb}px`

    // const remove=parseInt(point2.style.left, 10)+5
    //   const ababab=parseInt(line.style.width, 10)-remove

    //   line.style.width=`${ababab}px`

    //   // console.log"inp value ==2222222====r",line.style.width,"rrrrrrrrrrrrrrrrr======",ababab)
  };

  // console.log"api data in redux",car_report_detail_data)

  const dam3 = () => {
    // line.style.top="300px"
    car_div.style.top = "200px";
    // main.style.zoom = "50%";
  };
  const selectPoint = (item, index) => {
    if (activeIndex === index) {
      setActiveIndex(-1);
      setActivePoint(null);
      return;
    }
    setActiveIndex(index);
    setActivePoint(item);
  };

  const clearPoint = () => {
    setActiveIndex(-1);
    setActivePoint(null);
  };

  const legendEntries = buildLegend(legendTypes, damagePoints);
  const legend = () =>
    legendEntries.map((entry) => {
      const color = markerColor(entry.symbol);
      const present = entry.count > 0;
      return (
        <span
          key={`legend-${entry.symbol}`}
          className={`dd-report__legend-item${present ? " is-present" : ""}`}
        >
          <span
            className="dd-report__legend-swatch"
            style={{ background: color.bg }}
          >
            {entry.symbol}
          </span>
          <span className="dd-report__legend-copy">
            <strong>{entry.title}</strong>
            <em>{present ? `${entry.count} on map` : "Not on this lot"}</em>
          </span>
        </span>
      );
    });
  const closeviw = () => {
    setIsViewerOpen(false);
  };

  const [first, setfirst] = useState({
    photoIndex: 0,
    isOpen: false,
  });
  const { photoIndex, isOpen } = first;
  const activePhoto = pickPointPhoto(activePoint);
  const damagePhotos = damagePoints
    .map((item) => {
      const src = pickPointPhoto(item);
      if (!src) return null;
      return {
        src,
        symbol: item.symbol || "",
        label: item.title || "Damage photo",
      };
    })
    .filter(Boolean);

  const renderDamageMap = () => (
    <section className="dd-report__card">
      <h3 className="dd-report__card-title">Damage map</h3>
      <p className="dd-report__card-hint">
        {damagePoints.length
          ? "Select a marker to see the damage type, date, and photo. Click the same marker or the map to unselect."
          : "The inspection diagram is shown below. Markers appear after damage points are recorded for this lot."}
      </p>
      {activePoint ? (
        <div className="dd-report__point-info" ref={pointInfoRef}>
          <span
            className="dd-report__point-badge"
            style={{ background: markerColor(activePoint.symbol).bg }}
          >
            {activePoint.symbol || "•"}
          </span>
          <div className="dd-report__point-copy">
            <strong>
              {activePoint.title || activePoint.symbol || "Damage point"}
            </strong>
            <p>
              {formatPointDate(activePoint.date_added) ||
                "Inspection marker for this lot"}
            </p>
          </div>
          {activePhoto ? (
            <button
              type="button"
              className="dd-report__point-thumb"
              onClick={() => {
                const photos = damagePoints
                  .map((item) => {
                    const src = pickPointPhoto(item);
                    return src
                      ? {
                          src,
                          symbol: item.symbol || "",
                          label: item.title || "Damage photo",
                        }
                      : null;
                  })
                  .filter(Boolean);
                const start = photos.findIndex((photo) => photo.src === activePhoto);
                openGallery(photos, start < 0 ? 0 : start);
              }}
            >
              <img src={activePhoto} alt="" />
            </button>
          ) : (
            <span className="dd-report__point-empty">No photo attached</span>
          )}
          <button
            type="button"
            className="dd-report__point-clear"
            onClick={clearPoint}
            aria-label="Clear selected marker"
            title="Clear"
          >
            <FaTimes />
          </button>
        </div>
      ) : null}
      <div className="dd-report__map">
        <div
          className="dd-report__map-frame"
          onPointerDown={(event) => {
            if (event.target.closest(".dd-report__map-pin")) return;
            clearPoint();
          }}
        >
          <img
            className="dd-report__map-img"
            src={carDiagram}
            alt="Vehicle damage diagram"
          />
          {damagePoints.map((item, index) => {
            const color = markerColor(item.symbol);
            return (
              <button
                key={`pin-${index}-${item.symbol || "x"}`}
                type="button"
                className={`dd-report__map-pin${
                  activeIndex === index ? " is-active" : ""
                }`}
                style={{
                  top: mapOffset(item.top, MAP_HEIGHT),
                  left: mapOffset(item.left, MAP_WIDTH),
                  background: color.bg,
                  "--pin-color": color.bg,
                  "--pin-ring": color.ring,
                }}
                title={item.title || item.symbol}
                onPointerDown={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  selectPoint(item, index);
                }}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  selectPoint(item, index);
                }}
              >
                {item.symbol || String(index + 1)}
              </button>
            );
          })}
        </div>
      </div>
      {legendEntries.length > 0 ? (
        <div className="dd-report__legend">
          <h4>{car_report_page.car_legend_text || "Damage types"}</h4>
          <div className="title_list">{legend()}</div>
        </div>
      ) : null}
      {gallery.open ? (
        <ReportPhotoViewer
          items={gallery.items}
          index={gallery.index}
          onClose={closeGallery}
          onIndexChange={(next) =>
            setGallery((prev) => ({ ...prev, index: next }))
          }
        />
      ) : null}
    </section>
  );

  // loading
  if (winerListloading) {
    return (
      <div className="dd-report dd-report--loading">
        <ShimmerThumbnail height={180} rounded />
        <ShimmerThumbnail height={260} rounded />
      </div>
    );
  }

  if (!productCode) {
    return (
      <div className="dd-report dd-report--empty">
        <p>No vehicle selected for this report.</p>
        <button
          type="button"
          className="dd-report__btn"
          onClick={() => history.goBack()}
        >
          Go back
        </button>
      </div>
    );
  }

  const pdfHref = `/dealers/pdf/${encodeURIComponent(productCode)}/report`;
  const scoreBreakdown = overallFromSections(
    inspectionSections,
    damagePoints
  );
  const overallScore = scoreBreakdown.parts.length
    ? scoreBreakdown.score
    : roundScore(car_report_detail_data_new?.total_inspect);
  const overallTone = scoreTone(overallScore);

  if (!hasReport) {
    return (
      <div className="dd-report">
        <header className="dd-report__head">
          <div className="dd-report__head-copy">
            <p className="dd-report__eyebrow">Inspection</p>
            <h2>{car_report_page.report_text || "Vehicle report"}</h2>
            <p className="dd-report__ref">Lot reference #{productCode}</p>
          </div>
          <div className="dd-report__actions">
            <button
              type="button"
              className="dd-report__btn"
              onClick={() => history.goBack()}
            >
              Back to lot
            </button>
          </div>
        </header>

        <section className="dd-report__card dd-report__empty-card">
          <h3 className="dd-report__card-title">No inspection recorded yet</h3>
          <p className="dd-report__card-hint">
            This lot has not been inspected, so there are no checklist results
            to show. The report fills in once an inspection is completed for
            the vehicle.
          </p>
        </section>
        {renderDamageMap()}
      </div>
    );
  }

  return (
    <div className="dd-report">
      <header className="dd-report__head">
        <div className="dd-report__head-copy">
          <p className="dd-report__eyebrow">Inspection</p>
          <h2>{car_report_page.report_text || "Vehicle report"}</h2>
          <p className="dd-report__ref">Lot reference #{productCode}</p>
        </div>
        <div className="dd-report__actions">
          <button
            type="button"
            className="dd-report__btn"
            onClick={() => history.goBack()}
          >
            Back to lot
          </button>
          <a
            className="dd-report__btn dd-report__btn--primary"
            href={pdfHref}
            target="_blank"
            rel="noopener noreferrer"
          >
            Download PDF
          </a>
        </div>
      </header>

      <section className="dd-report__card dd-report__score">
        <div className="dd-report__score-hero">
          <div className={`dd-report__dial dd-report__dial--${overallTone.key}`}>
            <CircularProgressbarWithChildren
              value={overallScore}
              styles={buildStyles({
                pathColor: overallTone.color,
                trailColor: "rgba(15, 23, 42, 0.08)",
                strokeLinecap: "round",
                pathTransitionDuration: 0.6,
              })}
            >
              <div className="dd-report__dial-inner">
                <strong>{overallScore}</strong>
                <span>%</span>
              </div>
            </CircularProgressbarWithChildren>
            <p className="dd-report__grade">{overallTone.label}</p>
          </div>
          <div className="dd-report__score-main">
            <div className="dd-report__score-title" ref={scoreHelpRef}>
              <h3 className="dd-report__card-title">Overall inspection score</h3>
              <button
                type="button"
                className="dd-report__help"
                aria-label="How this score is calculated"
                aria-expanded={scoreHelpOpen}
                onClick={() => setScoreHelpOpen((open) => !open)}
              >
                <FaQuestionCircle />
              </button>
              {scoreHelpOpen ? (
                <div className="dd-report__help-pop" role="tooltip">
                  <p>
                    Overall % is the average of checklist section scores and the
                    damage-map score.
                  </p>
                  <p>
                    Each checklist section = 100 minus the damage weights of its
                    answers (for example Non-Accidented = 0, Accidented = 5).
                  </p>
                  <p>
                    Damage map = 100 minus the weight of every marker. Painted (P)
                    = 1, Minor Damage (D1) = 2. Other markers = 2.
                  </p>
                </div>
              ) : null}
            </div>
            <p className="dd-report__score-lead">
              This lot scores {overallScore}% overall across inspection
              sections{damagePoints.length ? " and the damage map" : ""}.
            </p>
            <div className="dd-report__score-tiles">
              {scoreBreakdown.parts.map((item, index) => {
                const tone = scoreTone(item.score);
                return (
                  <div
                    className={`dd-report__tile dd-report__tile--${tone.key}`}
                    key={`${item.title}-${index}`}
                  >
                    <div className="dd-report__tile-head">
                      <span>{item.title}</span>
                      <strong>{item.score}%</strong>
                    </div>
                    <div className="dd-report__tile-track">
                      <span
                        style={{
                          width: `${item.score}%`,
                          background: tone.color,
                        }}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {renderDamageMap()}

      {damagePhotos.length ? (
        <section className="dd-report__card">
          <h3 className="dd-report__card-title">Damage photos</h3>
          <p className="dd-report__card-hint">
            {damagePhotos.length} photo
            {damagePhotos.length === 1 ? "" : "s"} attached to damage markers.
            Click a photo to open it full screen.
          </p>
          <div className="dd-report__photos">
            {damagePhotos.map((photo, index) => (
              <button
                key={`damage-photo-${index}`}
                type="button"
                className="dd-report__photo"
                onClick={() => openGallery(damagePhotos, index)}
              >
                <img src={photo.src} alt="" />
                <span>
                  {[photo.symbol, photo.label].filter(Boolean).join(": ")}
                </span>
              </button>
            ))}
          </div>
        </section>
      ) : null}

      <section className="dd-report__card">
        <h3 className="dd-report__card-title">Inspection findings</h3>
        <div className="dd-report__sections">
          {React.Children.toArray(
            inspectionSections.map((item, key) => {
              const open = isSectionOpen(key);
              return (
                <div className={`dd-report__section${open ? " is-open" : ""}`}>
                  <button
                    type="button"
                    className="dd-report__section-head"
                    aria-expanded={open}
                    onClick={() => toggleSection(key)}
                  >
                      <img
                      className="dd-report__section-icon"
                      src={item.photo_url || Car_img2}
                      alt=""
                      onError={(event) => {
                        event.currentTarget.onerror = null;
                        event.currentTarget.src = Car_img2;
                      }}
                    />
                    <span className="dd-report__section-title">
                      {item.title}
                    </span>
                    <span
                      className={`dd-report__pct dd-report__pct--${
                        scoreTone(item.inspect_count).key
                      }`}
                    >
                      <strong>{`${item.inspect_count}%`}</strong>
                      <span className="dd-report__pct-track">
                        <i style={{ width: `${Number(item.inspect_count) || 0}%` }} />
                      </span>
                    </span>
                    <span className="dd-report__section-toggle" aria-hidden>
                      {open ? <FaMinus /> : <FaPlus />}
                    </span>
                  </button>

                  {open ? (
                    <div className="dd-report__section-body">
                      {React.Children.toArray(
                        item.inspection_title.map((entry) => {
                          const selected =
                            entry.selected_inspection_question?.[0] || null;
                          if (!selected) return null;
                          const photos = Array.isArray(selected.images_)
                            ? selected.images_
                            : [];
                          const firstPhoto =
                            photos
                              .map((photo) =>
                                typeof photo === "string"
                                  ? photo
                                  : photo?.image ||
                                    photo?.photo_url ||
                                    photo?.src ||
                                    ""
                              )
                              .find(Boolean) || "";
                          const thumb = firstPhoto || Car_img2;
                          return (
                            <div className="dd-report__finding">
                              <img
                                className="dd-report__finding-thumb"
                                src={thumb}
                                alt=""
                                onError={(event) => {
                                  event.currentTarget.onerror = null;
                                  event.currentTarget.src = Car_img2;
                                }}
                              />
                              <div className="dd-report__finding-copy">
                                <h4>{entry.question}</h4>
                                {firstPhoto ? (
                                  <button
                                    type="button"
                                    className="dd-report__finding-link"
                                    onClick={() => imge_wiew(photos)}
                                  >
                                    <BiImage size={18} /> View image
                                  </button>
                                ) : null}
                              </div>
                              <span className="dd-report__finding-answer">
                                {selected.choice_select_}
                              </span>
                            </div>
                          );
                        })
                      )}
                    </div>
                  ) : null}
                </div>
              );
            })
          )}
        </div>
      </section>

      <footer className="dd-report__foot">
        <a
          className="dd-report__btn dd-report__btn--primary"
          href={pdfHref}
          target="_blank"
          rel="noopener noreferrer"
        >
          Download PDF report
        </a>
      </footer>
    </div>
  );
};

const mapStateToProps = (state) => ({
  car_report_data: state.carreport.car_report_data,
  car_report_detail_data: state.carreport.car_report_detail_data.data,
  car_report_detail_data_new: state.carreport.car_report_detail_data,
  loading: state.carreport.loading,
  winerListloading: state.carreport.winerListloading,
  addresform: state.shiping.addresform,
});
const mapDispatchToProps = (dispatch) => ({
  // car report
  car_report_call: (data) =>
    dispatch({
      type: CAR_REPORT,
      payload: {
        type: CAR_REPORT,
        method: POST,
        label: Labels.car_report,
        hideOverlayLoader: true,
        data,
      },
    }),
  // car report detail
  car_report_detail_call: (data) =>
    dispatch({
      type: CAR_REPORT_DETAIL,
      payload: {
        type: CAR_REPORT_DETAIL,
        method: POST,
        label: Labels.car_report_detail,
        hideOverlayLoader: true,
        data,
      },
    }),

  //
});

export default connect(mapStateToProps, mapDispatchToProps)(CarReport);
